import React, {Component} from 'react'
import PropTypes from 'prop-types'
import i18n from 'i18next'
import actions from 'redux-auto'
import {connect} from 'react-redux'
import ArrowDown from '#components/svg/icons/ArrowDown'
import AzubiListHOC from '#components/HOC/AzubiListHOC'
import CheckboxFilterDialog from './checkboxFilterDialog'
import SortingDialog from './SortingDialog'
import {GLOBAL_FILTERS} from './filterDialogTypes'

export class Filterdialog extends Component {
  render() {
    const {text, type, sortOptions, filterOptions, isVersetzungsplan, filterRules, showAscAndDescSortingOption} =
      this.props

    const hasFilterOptions = !GLOBAL_FILTERS.includes(type) && filterOptions && filterOptions.length > 0
    return (
      <div className="filter" data-testid={`filter-${type}`}>
        <div className="filter__headline">
          <span>{i18n.t(text)}</span>
          <ArrowDown />
        </div>
        {showAscAndDescSortingOption && <SortingDialog sortOptions={sortOptions} type={type} />}
        {hasFilterOptions && showAscAndDescSortingOption && <div className="spacer" />}
        {hasFilterOptions && (
          <CheckboxFilterDialog
            checkboxOptions={filterOptions}
            type={type}
            filterRules={filterRules}
            toggleFilterRule={
              isVersetzungsplan ? this.props.toggleFilterRuleVersetzungsplan : this.props.toggleFilterRuleMeineAzubis
            }
          />
        )}
      </div>
    )
  }
}

Filterdialog.propTypes = {
  text: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  sortOptions: PropTypes.object.isRequired,
  filterOptions: PropTypes.arrayOf(PropTypes.string),
  isVersetzungsplan: PropTypes.bool,
  toggleFilterRuleMeineAzubis: PropTypes.func,
  toggleFilterRuleVersetzungsplan: PropTypes.func,
  filterRules: PropTypes.array.isRequired,
  showAscAndDescSortingOption: PropTypes.bool,
}

const mapDispatchToProps = () => ({
  toggleFilterRuleMeineAzubis: actions.meineAzubis.toggleFilterRule,
  toggleFilterRuleVersetzungsplan: actions.versetzungsplan.toggleFilterRule,
})

const mapStateToProps = (state, props) => {
  if (props.isVersetzungsplan) {
    return {
      filterRules: state.versetzungsplan.filterRules,
      sortOptions: state.meineAzubis.sortOptions,
    }
  }
  return {
    filterRules: state.meineAzubis.filterRules,
    sortOptions: state.meineAzubis.sortOptions,
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(AzubiListHOC(Filterdialog))
